import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import { fetchApi } from '../../services/apiService';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const TyrePositionAutocomplete = forwardRef((props, ref) => {
    const { allOption, selectedValues = [], isFormikFormField = false, showFormError = false, vehicleId = null, width = "100%", listWidth = width, ...rest } = props;
    let tyrePositionOptions = [];

    let initialProps = {
        ...rest,
        labelKey: 'label',
        primaryKey: 'value',
        options: tyrePositionOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        dataLoaded: false,
        listWidth,
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    const userToken = useSelector((state) => state.login.userToken);

    useEffect(() => {
        const getTyrePositionOptions = async () => {
            let getTyrePositionParams = {};
            if (vehicleId && vehicleId !== '') {
                getTyrePositionParams = { ...getTyrePositionParams, vehicleId: vehicleId }
            }
            const response = await fetchApi('transactions/getTyrePositionsForAutocomplete', getTyrePositionParams, userToken);
            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                let newOptions = [];
                if (response.data.tyrePositions.length > 0) {
                    newOptions = newOptions.concat(response.data.tyrePositions);
                }
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((t) => selectedValues.indexOf(t.value) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
            else {
                const newProps = { ...defaultProps, options: [], preSelectedValues: [], dataLoaded: true };
                setDefaultProps(newProps);
            }
        }
        getTyrePositionOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (defaultProps.dataLoaded ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default TyrePositionAutocomplete;